import Http from '@/utils/http';
import {
    AppResponse,
    IVCourseResult,
    IStudyToolResult,
    CanlendarLiveData,
    ICalendarData,
    ExamResponse,
    IResourcesCoverListItem,
} from '@/types';

// 获取学生信息
export const getStudentInfo = (): Promise<AppResponse<{ days: number; headImgUrl: string; nickName: string; userId: number }>> =>
    Http.get('/passport/api/v3/user/get-user-info-by-token');

// 获取学生信息
export const getStudentExtraInfo = (): Promise<AppResponse<{ item_done: number }>> => Http.get('/ep-course/api/v1/space/student/info');

// 学习空间-pc版-v2
export const getProjectsAndCourses = (params?: { courseStatus: number }): Promise<AppResponse<IVCourseResult>> =>
    Http.get('/ep-course/api/v2/front/space/vcourse/pc', params);

// 获取学习空间首页banner和学习工具
export const getStudyTool = (params: { projectId: number; source: 1 }): Promise<AppResponse<IStudyToolResult>> =>
    Http.get('/study-tool/api/v1/front/study-tool/homepage', params);

// 获取三个月内直播数据 /live-student/live/list/g2
export const getTreeMonthsLiveData = (): Promise<AppResponse<CanlendarLiveData[]>> => Http.get('/hermes/live-student/live/list/g2');

// 今日任务与日历(包含面授)
export const getCalendarData = (params: {
    startTime: string;
    endTime: string;
    isOneDay?: 0 | 1; // 是否是单日数据0不是，1是
    forPc: true; // 是否要PC简化版
    trial: 1; // 体验课1
    projectId: number;
}): Promise<AppResponse<ICalendarData>> => Http.get('/g-study/api/v1/front/gl/all-calendar-server', params);

// 设置考试
export const setMyExamDate = (params: { examDate: string; projectId: number; subjectId: number }): Promise<AppResponse<boolean>> =>
    Http.post('/ep-course/api/v1/space/exam-date/save', params);

// 查询考试
export const getStudentExamDate = (params: { subjectIds: string }): Promise<AppResponse<ExamResponse>> =>
    Http.get('/ep-course/api/v1/space/student/exam-date', params);

// 删除考试
export const deleteMyExamDate = (id: number) => Http.delete(`/ep-course/api/v1/space/exam-date/${id}`);

// 更新考试
export const updateMyExamDate = (id: number, params: { examDate: string; projectId: number; subjectId: number }) =>
    Http.put(`/ep-course/api/v1/space/exam-date/${id}`, params);

// 获取第三方课程的跳转地址
export const getOtherPartnerMarkLink = (params: { otherPartnerMark: string; courseId: number }): Promise<AppResponse<{ url: string }>> =>
    Http.get('/ep-course/api/v1/front/course/url', params);

// 获取saas课继续学习资源的详情
export const getCourseLearningResource = (params: { course_id: number }): Promise<AppResponse<any>> =>
    Http.get('/ep-study/front/learning-resource', params);

// 获取讲义资源的加密地址
export const getLectureNoteAuthPath = (params: { resource_id: number; filename: string }): Promise<AppResponse<string>> =>
    Http.get('/hermes/front/v1/download/resource', params);

// 获取封面图
export const getResourcesCover = (params: { resourceIds: string }): Promise<AppResponse<IResourcesCoverListItem[]>> =>
    Http.get('/ep-study/api/v1/front/resource/cover', params);

// 课程排序
export const sortPackageCourse = (courseId: number, params: { courseIds: number[] }): Promise<AppResponse<any>> =>
    Http.post(`/ep-course/api/v1/space/package/${courseId}/change/sort`, params);

// 老学习空间 获取学生是否是新用户的，会返回学生Id
export const verify = (params = {}) => Http.get('/ep-course/api/v1/space/student/verify', params);

// 验证学员是否正价课 跳转不同的客服
export const getUserCheck = () => Http.get(`/aismo/sobot/v1/user/check`);
